import { render, staticRenderFns } from "./ZxMenu.vue?vue&type=template&id=8bd4b2d4&scoped=true&"
import script from "./ZxMenu.vue?vue&type=script&lang=js&"
export * from "./ZxMenu.vue?vue&type=script&lang=js&"
import style0 from "./ZxMenu.vue?vue&type=style&index=0&id=8bd4b2d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd4b2d4",
  null
  
)

component.options.__file = "ZxMenu.vue"
export default component.exports